// extracted by mini-css-extract-plugin
export default {"banner":"banners_banner__E8HIt","bannerVideo":"banners_bannerVideo__17wcw"};